// extracted by mini-css-extract-plugin
module.exports = {"article":"news-article-module--article--2C1rj"};